import React, { useEffect, useState } from "react";
import { getPriorityList } from "../lib/api";
import { StatusPill } from "./Badges";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "./ui/table";
import { Phone, Target } from "lucide-react";
import { probColor } from "../lib/constants";
import { TREND } from "./plan/AcquisitionSummary";

export const PriorityList = ({ onOpen, refreshKey }) => {
  const [data, setData] = useState({ items: [], total_active: 0, history: { won: 0, lost: 0 } });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    getPriorityList(100).then(setData).catch((e) => console.warn("priority list load failed", e)).finally(() => setLoading(false));
  }, [refreshKey]);

  return (
    <div className="space-y-3" data-testid="priority-list">
      <div className="flex flex-wrap items-center justify-between gap-2 text-xs text-muted-foreground">
        <span className="flex items-center gap-2"><Target className="h-3.5 w-3.5 text-primary" /> Classifica calcolata su bisogno, fit, raggiungibilità, budget, andamento e storico pipeline ({data.history.won} vinti / {data.history.lost} persi).</span>
        <span>{data.total_active} prospect attivi</span>
      </div>
      <div className="overflow-hidden rounded-xl border border-border bg-card">
        <Table>
          <TableHeader>
            <TableRow className="border-border hover:bg-transparent">
              <TableHead className="w-12">#</TableHead>
              <TableHead>Azienda</TableHead>
              <TableHead>Acquisizione</TableHead>
              <TableHead>Indice</TableHead>
              <TableHead>Sito · Social · Adv</TableHead>
              <TableHead>Trend</TableHead>
              <TableHead>Stato</TableHead>
              <TableHead>Perché ora</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {data.items.map((it) => {
              const trend = TREND[it.trend] || TREND["n.d."];
              const TIcon = trend.icon;
              return (
                <TableRow key={it.id} onClick={() => onOpen(it.id)} className="cursor-pointer border-border" data-testid={`priority-row-${it.id}`}>
                  <TableCell className="font-heading text-lg font-bold tabular-nums text-muted-foreground">{it.rank}</TableCell>
                  <TableCell className="font-medium">
                    {it.azienda}
                    <div className="text-xs text-muted-foreground">{[it.settore, it.citta].filter(Boolean).join(" · ")}{it.telefono && <Phone className="ml-1 inline h-3 w-3 text-[#22C55E]" />}</div>
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <span className="font-heading text-xl font-bold tabular-nums" style={{ color: probColor(it.probability) }} data-testid={`priority-prob-${it.id}`}>{it.probability}%</span>
                      <div className="h-1.5 w-16 rounded bg-secondary"><div className="h-full rounded" style={{ width: `${it.probability}%`, background: probColor(it.probability) }} /></div>
                    </div>
                  </TableCell>
                  <TableCell className="tabular-nums text-primary">{it.priority_index}</TableCell>
                  <TableCell className="text-xs tabular-nums text-muted-foreground">{it.channel_scores?.sito} · {it.channel_scores?.social} · {it.channel_scores?.google_adv}</TableCell>
                  <TableCell><TIcon className="h-4 w-4" style={{ color: trend.color }} /></TableCell>
                  <TableCell><StatusPill status={it.status} /></TableCell>
                  <TableCell className="max-w-[260px] text-xs text-muted-foreground">{(it.reasons || []).slice(0, 2).join(" · ") || "—"}</TableCell>
                </TableRow>
              );
            })}
            {!loading && data.items.length === 0 && (
              <TableRow><TableCell colSpan={8} className="py-12 text-center text-muted-foreground">Nessun prospect attivo.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </div>
    </div>
  );
};
